import styles from './privacy.module.css';

const Privacy = () => {

    return (
        <div id={styles.mainContainer}>
            <div id={styles.wrapper}>
                <h2 className={styles.title}>Privacy Policy</h2>
                <div className={styles.innerWrapper}>
                    <div className={styles.eachContainer}>
                        <h4>Introduction</h4>
                        <p>This Policy contains important information about who we are, how and why we collect,
                            store, use, and share the information you give to us. It also explains your rights regarding our
                            information collection practices and your choices about how we use the information we
                            collect.We regularly review our Privacy Policy and update its contents as needed. Updates will be
                            posted on this web page as they are made.This Policy was last updated on May 3, 2023.</p>
                    </div>

                    <div className={styles.eachContainer}>
                        <h4>What does this Privacy Statement cover?</h4>
                        <p>This Privacy Statement applies to any personal data We may process about you that maybe
                            collected directly from you when you interact with Us or from third parties, such as when
                            you:</p>
                        <ul>
                            <li>Visit our public-facing Global Spark Tek Solutions branded websites and social media pages;
                            </li>
                            <li>
                                Send or receive communications from/to us, including emails, phone calls, texts or faxes;
                            </li>
                            <li>
                                Use our products and services (for example, as an employee of one of our customers who provided you with access to our products or services) to the extent that We are acting as a controller of your personal data. You should be aware that processing of personal data is required for receiving certain products or services;
                            </li>
                            <li>
                                Access downloadable applications from mobile devices in line with respective privacy statements.
                            </li>
                            <li>
                                Register for, attend, or take part in activities such as events, webinars, training, campaigns, or contests;
                            </li>
                            <li>
                                Visit our offices
                            </li>
                            <li>
                                Access, use, or download content from us (newsletters, whitepapers, reports etc).
                            </li>

                        </ul>
                        <p>
                            This Privacy Statement will be available via link on all sites and services which it covers. The information practices of other services, or of social media platforms that host our branded social media pages, are governed by their privacy statements, which you should review to better understand their privacy practices.
                        </p>
                        <p>
                            Our websites and offerings are directed to people in their business or professional capacities. They are not intended for children under 18 years of age. We do not knowingly solicit information online from, or market online to, children under 18 years of age. If you are a parent or guardian and believe your child has provided Us with personal data without your consent, please contact Us as indicated below and We will take steps to delete their
                            personal data from our systems.
                        </p>
                        <p>
                            This Privacy Statement does not apply to the extent We process personal data in the role of a data processor or service provider, including personal data processed on behalf of our customers.
                        </p>
                    </div>


                    <div className={styles.eachContainer}>
                        <h4>What personal data Collected from you?</h4>
                        <ul>
                            <li>
                                Your business contact information, including your name, job title, company name, physical address, phone number, fax number, and email address.
                            </li>
                            <li>
                                Account numbers and other similar financial data.
                            </li>
                            <li>
                                Your personal contract information and other data required to consider hiring you as an employee or subcontractor.
                            </li>
                            <li>
                                Internet Protocol (IP) addresses, the region or general location where your computer or device is accessing the internet, browser type, operating system and other usage information about the use of our website, including a history of the pages you view.
                            </li>

                        </ul>
                    </div>
                    <div className={styles.eachContainer}>
                        <h4>How We Collect Data from You?
                        </h4>
                        <p>We collect this personal information directly from you through the following methods:</p>
                        <ul>
                            <li>Trade shows and conferences.</li>
                            <li>Forms completed by website visitors, including chat vendors</li>
                            <li>Third party websites and search providers.</li>
                            <li>Website cookies.</li>
                            <li>Customer contact information.</li>
                            <li>Customer agreements and their associated addendums.</li>
                            <li>Forms and various methods used to capture job candidate information.</li>

                            <li>Vendor and subcontractor agreements and their associated addendums.</li>
                            <li>We may also collect personal information about you directly from third parties:

                            </li>
                        </ul>
                        <p>In connection with providing Services pursuant to contracts with our corporate clients, we often obtain personal information of our client’s customers, employees and/or agents. This personal information varies based on the Services provided, but
                            may include names, contact information, account numbers and other similar financial data. With respect to personal information that we receive from or on behalf of our clients to provide Services, our client remains the independent data controller and we act as a processor of such personal information.
                        </p>
                    </div>

                    <div className={styles.eachContainer}>
                        <h4>How we will use your personal data?
                        </h4>
                        <p>We may use your information in the following ways:</p>
                        <ul>
                            <li>Marketing and sales purposes.        </li>
                            <li>Business and website analytics.       </li>
                            <li>To improve our products and services.        </li>
                            <li>To perform our contractual obligations to you where one exists.       </li>
                            <li>To prevent and detect fraud against you and us. We may use your IP address, the region or general location where your computer or device is accessing the internet, browser type, operating system and your use history of our website to help us design our site to better suit your needs and make the Site easier and more convenient to use.</li>
                            <li>We may use your IP address to help diagnose problems with our server and to administer our website, analyze trends, track visitor movements, and gather broad demographic information that assists us in identifying visitor preferences.  </li>
                        </ul>
                    </div>


                    <div className={styles.eachContainer}>

                        <h4>How long do We retain your personal data?</h4>
                        <p>We retain your personal data for as long as it is necessary to fulfil the purposes for which it
                            was collected, or longer if required to fulfil our legal and contractual obligations. After
                            expiration of the retention period, your personal data will be deleted. If We are unable to
                            completely delete the personal data from our systems, We will ensure that there are
                            appropriate measures in place to secure the information and protect it from further use.</p>
                    </div>

                    <div className={styles.eachContainer}>
                        <h4>With whom do We share your personal data?</h4>
                        <p>We only use, disclose, or otherwise process personal information when we have a lawful basis for doing so under applicable laws, including fulfilling our contractual obligations, complying with legal obligations, protecting the vital interests of a person, furthering our legitimate interests as a company, and for reasons to which you have consented.</p>
                        <p>We may also share personal information with the following categories of third
                            parties:</p>
                        <ul>
                            <li>
                                Sub-contractors we have engaged in connection with providing Services to our clients.
                            </li>
                            <li>

                                Clients that require your personal information in order for you to provide Services to our clients as a Sub-contractor.
                            </li>
                            <li>
                                Our professional advisers, including our attorneys and accountants.
                            </li>
                            <li>
                                Third parties to which we outsource certain services to assist with operating our business, such as IT managed service providers, document shredding services, software providers, information storage providers and other related service providers.
                            </li>
                            <li>
                                Third parties to which our clients have directed us to share information in connection with our Services, such as our clients’ attorneys and accountants.
                            </li>
                            <li>
                                Third-party service providers that assist us with client data analytics.
                            </li>
                            <li>
                                Third-party postal or courier providers that assist us with delivering marketing and other documents to you.
                            </li>
                            <p>
                                We will only share information that we collect or receive regarding our users with third parties under the following circumstances:
                            </p>
                            <ul>
                                <li>
                                    <span>Consent:</span>  If we have a user’s consent to share any information, we may do so. We will provide an individual opt-out choice, or opt-in for sensitive data or required by an applicable regulation, before we share your data with third parties other than our agents, or before we use it for a purpose other than which it was originally collected
                                    or subsequently authorized. To request to limit the use and disclosure of your personal information, please mail to info@globalsparktek.com.

                                </li>
                                <li>
                                    <span>Agents:</span>
                                    We may utilize other companies and individuals to perform functions on its behalf such as marketing new or additional services, sending postal and electronic mail to users, and hosting discussion forums. Such third parties have access to information needed to perform their functions but may not use it for other
                                    purposes.
                                </li>
                                <li>
                                    <span>Aggregate Anonymous Information: </span>
                                    We may provide to others the aggregate statistics about our users’ site activity for purposes of marketing, promotion, analytics, or similar activities. None of these statistics will identify users personally.
                                </li>
                                <li>
                                    <span>Business Transfers: </span>
                                    If we decide to sell all or part or our assets, we reserve the right to include information among the assets transferred to the acquiring company.
                                </li>
                                <li>
                                    <span>Affiliates and Subsidiaries: </span>
                                    We may share information among its affiliates and subsidiaries for the same purposes that we use the information.
                                </li>
                            </ul>

                        </ul>
                    </div>

                    <div className={styles.eachContainer}>
                        <h4>How do We safeguard your personal data?
                        </h4>
                        <p>
                            We use a range of security measures to protect your personal data from unauthorized or unlawful access, loss, disclosure, or alteration, including technical, organizational and physical measures. We have sufficient controls, policies, procedures and guidance in line with industry best practices and information security standards such as ISO27001 etc. to
                            ensure security of personal data is maintained at all stages of its lifecycle.

                        </p>
                    </div>

                    <div className={styles.eachContainer}>
                        <h4>How can you contact Us if you have any questions?</h4>
                        <p>If you have any questions or concerns about this Privacy Statement or how your Personal Data is processed then you can contact the Privacy Office at info@globalsparktek.com Tel (+91 6303593501)</p>
                    </div>
                </div>
            </div>

        </div>
    )


}


export default Privacy